<div class="chart-container">
  <apx-chart
    #chart
    [series]="chartOptions().series"
    [chart]="chartOptions().chart"
    [xaxis]="chartOptions().xaxis"
    [yaxis]="chartOptions().yaxis"
    [dataLabels]="chartOptions().dataLabels"
    [stroke]="chartOptions().stroke"
    [tooltip]="chartOptions().tooltip"
    [annotations]="chartOptions().annotations"
  ></apx-chart>
</div>
